<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("customermanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("customerlist")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 250px"
        v-model:value="customerList.keyWord"
        :placeholder="t('pleaseentercustomernamevehiclevinworkstationzin')"
      />
      <a-button type="primary" class="searchBtn" @click="hadnleSearch">{{
        t("search")
      }}</a-button>
      <a-button type="primary" class="searchBtn addBtn" @click="addCustomer">{{
        t("newcustomer")
      }}</a-button>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 1400 }"
    >
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.title === t('workstationmode')">
          {{ WorkStationModel(JSON.parse(record.extension)?.type) }}</template
        >
        <template v-if="column.title === t('operate')">
          <div class="operate">
            <a-dropdown :trigger="['click']">
              <a class="ant-dropdown-link" @click="checkItem(record)">
                <img
                  v-if="record.id !== checkedId"
                  src="../assets/images/notclicked.png"
                  alt=""
                />
                <img v-else src="../assets/images/clicked.png" alt="" />
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="0" @click="toUserManagement(record.id)">
                    {{ t("usermanage") }}</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item key="1" @click="goCarList(record.id)"
                    >{{ t("vehiclemanagement") }}({{
                      record.vinCount
                    }})</a-menu-item
                  ><a-menu-divider />
                  <a-menu-item key="2" @click="goWorkstation(record.id)"
                    >{{ t("workstationmanagement") }}({{
                      record.zinCount
                    }})</a-menu-item
                  >
                  <a-menu-divider />
                  <a-menu-item key="3" @click="customerEdit(record.id)">{{
                    t("edit")
                  }}</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      v-model:current="customerList.page"
      v-model:pageSize="customerList.size"
      :total="totalNum"
      size="small"
      show-size-changer
      show-quick-jumper
      :show-total="(totalNum) => `${t('intotal')} ${totalNum} ${t('article')}`"
      @change="handlePaginationChange"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { defineComponent, onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { delayClick } from "@/utils/MyUtils";
import { useI18n } from "vue-i18n";
export default defineComponent({
  setup() {
    const { t } = useI18n();
    const dataSource = ref();
    const totalNum = ref(0);
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const checkedId = ref("");
    const customerList = ref({
      keyWord: "",
      owner: sessionStorage.getItem("username"),
      page: 1,
      size: 10,
    });
    const router = useRouter();
    const getListData = () => {
      Api.getCustomerList(customerList.value).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          customerList.value.page = res.page;
          totalNum.value = res.total_num;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const WorkStationModel = (key) => {
      let str = "";
      switch (key) {
        case 0:
          str = t("offlinepile");
          break;
        case 1:
          str = t("exclusivestake");
          break;
        case 2:
          str = t("sharedstake");
          break;
      }
      return str;
    };
    const handlePaginationChange = (page, pageSize) => {
      customerList.value.page = page;
      customerList.value.size = pageSize;
      getListData();
    };
    const hadnleSearch = () => {
      customerList.value.page = 1;
      getListData();
    };
    const goCarList = (id) => {
      router.push({ path: routerName.vehicleManagement, query: { id } });
    };
    const addCustomer = () => {
      router.push({ path: routerName.customerCreate, params: {} });
    };
    const goWorkstation = (id) => {
      router.push({ path: routerName.WorkStationManagement, query: { id } });
    };
    const toUserManagement = (id) => {
      router.push({
        path: routerName.OrgUserManagement,
        query: { id: id },
      });
    };
    const customerEdit = (id) => {
      router.push({
        path: routerName.customerCreate,
        query: { id: id, isEdit: 1 },
      });
    };
    const checkItem = (value) => {
      checkedId.value = value.id;
    };
    onMounted(() => {
      getListData();
    });

    return {
      checkItem,
      checkedId,
      dataSource,
      columns: [
        {
          title: t("customername"),
          dataIndex: "organizationName",
          key: "organizationName",
          align: "center",
        },
        {
          title: t("vehiclevin"),
          dataIndex: "vin",
          key: "vin",
          align: "center",
        },
        {
          title: t("workstationmode"),
          dataIndex: "status",
          key: "status",
          align: "center",
        },
        {
          title: t("workstationzin"),
          dataIndex: "zin",
          key: "zin",
          align: "center",
        },
        {
          title: t("creationtime"),
          dataIndex: "createTime",
          key: "createTime",
          align: "center",
        },
        {
          title: t("founder"),
          dataIndex: "owner",
          key: "owner",
          align: "center",
        },
        {
          title: t("operate"),
          dataIndex: "operate_status",
          key: "operate_status",
          align: "center",
          width: 100,
        },
      ],
      customerList,
      totalNum,
      handlePaginationChange,
      hadnleSearch,
      goCarList,
      goWorkstation,
      toUserManagement,
      addCustomer,
      customerEdit,
      WorkStationModel,
      maxHeight,
      t,
    };
  },
});
</script>
<style scoped></style>
